import { DataLayerEcommerceProduct } from './types'

const createDataLayerEcommerceProduct = (
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  variant: any
): DataLayerEcommerceProduct => ({
  name: variant?.globalArticleName || '-',
  id: variant?.globalArticleCode || '-',
  price: variant?.price?.value || '-',
  brand: variant?.brand || '-',
  category: variant?.productFamily || '-',
  variant: variant?.nuance?.description || '-',
  dimension51: variant?.deviceVersion || 'n/a',
  dimension52: variant?.stock?.stockLevelStatus || '-',
  dimension54: 'n/a',
  // dimension55: 'standard', value will be provided in future
  dimension57: false,
  dimension58: variant.pmiInternalProductCode || '-',
  dimension59: 'n/a', // value will be provided in futures
  metric11: variant?.price?.value
})

export default createDataLayerEcommerceProduct
